export const contact = {
  name: 'Duran Media Solutions',
  street: '7474 NW 145 St',
  city: 'Miami Lakes, Florida 33014',
  phone: '(786) 278-1465',
  phoneHref: 'tel:+17862781465',
  email: 'info@duranmediasolutions.com',
  facebookLabel: 'facebook.com/DuranMediaSolutions',
  facebookUrl: 'https://www.facebook.com/DuranMediaSolutions',
  youtubeUrl: 'https://www.youtube.com/channel/UCD4EMzHdywUigGApdAbEUvg/',
  mapUrl: 'https://www.google.com/maps/search/?api=1&query=7474+NW+145+St+Miami+Lakes+Florida+33014'
};